import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "../../api/client";
import { qk } from "../../api/keys";

export const timelineKey = (videoId: number) => qk.entity("video", videoId, "timeline");

export function useTimeline(videoId: number) {
  return useQuery({
    queryKey: timelineKey(videoId),
    queryFn: () => unwrap(api.GET("/api/videos/{video_id}/timeline", { params: { path: { video_id: videoId } } })),
  });
}

/** Title etc. (WS1 route); optional — the page works without it. */
export function useVideoTitle(videoId: number) {
  return useQuery({
    queryKey: qk.entity("video", videoId, "detail"),
    retry: false,
    queryFn: () => unwrap(api.GET("/api/videos/{video_id}", { params: { path: { video_id: videoId } } })),
  });
}

/** Source, lock and confidence of the song's lyrics (WS2 route); optional. */
export function useLyricsInfo(songId: number | null | undefined) {
  return useQuery({
    queryKey: qk.entity("song", songId ?? 0, "lyrics"),
    enabled: songId != null,
    retry: false,
    queryFn: () => unwrap(api.GET("/api/songs/{song_id}/lyrics", { params: { path: { song_id: songId as number } } })),
  });
}

/** Clips of a video as board subitems: carries the clip pipeline steps (cut status). */
export function useClipSubitems(videoId: number) {
  return useQuery({
    queryKey: qk.subitems("videos", videoId),
    queryFn: () => unwrap(api.GET("/api/board/{group}/{item_id}/subitems",
      { params: { path: { group: "videos", item_id: videoId } } })),
  });
}
